"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ROLE_TYPES = exports.OrganizationType = void 0;
// many of types will eventually be removed, as these are defined within
// context of CA
var OrganizationType;
(function (OrganizationType) {
    OrganizationType["AdminAgent"] = "adminAgent";
    OrganizationType["BackupServicer"] = "backupServicer";
    OrganizationType["Borrower"] = "borrower";
    OrganizationType["CapitalProvider"] = "capitalProvider";
    OrganizationType["CapitalProviderRepresentative"] = "capitalProviderRepresentative";
    OrganizationType["CollectionAccountBank"] = "collectionAccountBank";
    OrganizationType["PayingAgent"] = "payingAgent";
    OrganizationType["Servicer"] = "servicer";
    OrganizationType["Special"] = "special";
    OrganizationType["VerificationAgent"] = "verificationAgent";
})(OrganizationType = exports.OrganizationType || (exports.OrganizationType = {}));
exports.USER_ROLE_TYPES = [
    'ADMIN',
    'MEMBER',
    'CONTRIBUTOR',
];
//# sourceMappingURL=Organization.js.map